import JsonApi from 'devour-client';
import { GuestPayload } from './GuestPayload';
import { ServiceBase } from './ServiceBase';

export class GuestService extends ServiceBase<GuestPayload> {
  constructor(jsonApi: JsonApi) {
    const schema = GuestPayload.getSchema();
    super(jsonApi, 'guest', schema, GuestPayload);
  }

  getByIdExtra = async (id: string) => {
    const guestFields = 'outstanding_balance,lifetime_spent,most_recent_reservation';
    const extra = { guests: guestFields };
    const data = this.findById(id, { extra_fields: extra });
    return data;
  }
}
